@if (!linkText) {
  <button
    fdCompact
    tabindex="-1"
    fd-button
    [fdType]="'transparent'"
    class="help-button"
    [title]="tooltip"
    i18-title="XTOL|Button tooltip for More Info button@moreInfoButtonTooltip"
    [disabled]="!enabled"
    [fdPopoverTrigger]="helpPopover"
    (click)="onClick()"
  >
    <app-icon [icon]="icon" size="lg"></app-icon>
  </button>
} @else {
  <a
    fd-link
    href="#"
    (click)="onClickLink()"
    [title]="linkTooltip"
    [emphasized]="linkEmphasized"
  >
    <span class="link-inner-container">
      @if (linkIconEnabled) {
        <app-icon [icon]="icon" class="link-icon" size="lg"></app-icon>
      }
      {{ linkText }}
    </span>
  </a>
}
<fd-popover
  #helpPopover
  [placement]="placement"
  [noArrow]="true"
  [(isOpen)]="isOpen"
>
  @if (isOpen) {
    <div class="help-popover" [ngStyle]="{ width: width }">
      @if (!!headerTitle) {
        <div fd-popover-body-header>
          <div fd-bar>
            <div fd-bar-left>
              <fd-bar-element class="popover-title">{{
                this.headerTitle
              }}</fd-bar-element>
            </div>
          </div>
        </div>
      }
      <div class="popover-body">
        <ng-container *ngTemplateOutlet="body"></ng-container>
      </div>
    </div>
  }
</fd-popover>
